/**
 * 서버 실패 문구(BE meta.message → detail → message, 없으면 fallback) — **글자만** 돌려준다.
 * `Utils.getApiErrMessage` 는 옛 알럿용으로 빨간 별표 HTML(`<span …> *</span>`)을 덧붙여, 토스트·새 알럿에 넘기면 태그가 글자로 보인다(#899 리뷰).
 * 여러 건(배열)은 줄바꿈으로 잇는다 — 토스트·알럿 모두 pre-line 이다.
 */
const toText = (v: unknown): string => {
  if (Array.isArray(v)) return v.filter((m): m is string => typeof m === 'string' && m.trim() !== '').join('\n')
  return typeof v === 'string' ? v.trim() : ''
}

export const apiErrorText = (e: unknown, fallback: string): string => {
  const data = (e as { response?: { data?: { meta?: { message?: unknown }; detail?: unknown; message?: unknown } } } | null | undefined)?.response?.data
  // 후보마다 글자로 만들어 **처음 비지 않은 것** — 빈 배열·빈 문자열 후보에서 멈추면 뒤의 서버 문구를 놓친다(#899 리뷰 sookeunwoo).
  return [data?.meta?.message, data?.detail, data?.message].map(toText).find((t) => t !== '') ?? fallback
}
